module.exports = __webpack_public_path__ + "static/img/qiyeweixin1.7e3065e.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qiyeweixin1.jpeg
// module id = 3fPf
// module chunks = 0